<template>
  <span id="unit-page__progress">
    <div class="kt-portlet">
      <div
        class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
      >
        <div
          class="d-flex justify-content-center align-items-center align-content-center w-100"
        >
          <h3 class="kt-portlet__head-title">Unit Progress</h3>
          <span class="mr-auto"></span>
          <div class="text-right">
            <v-dialog transition="dialog-top-transition" max-width="600">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  text
                  v-bind="attrs"
                  v-on="on"
                  @click="fetchUnitHistory()"
                  >Show Unit History</v-btn
                >
              </template>
              <template v-slot:default="showHistoryDialog">
                <v-card>
                  <v-toolbar color="primary" dark>Unit History</v-toolbar>
                  <v-card-text class="pa-0 ma-0">
                    <div class="pa-0 ma-0 w-100">
                      <v-data-table
                        :headers="headers"
                        :items="unitHistory"
                        class="elevation-1"
                        :items-per-page="per_page"
                        :server-items-length="pagination.total"
                        :loading="loading.fetching"
                        :disabled="loading.fetching"
                        @update:page="changePage"
                        @update:sort-by="updateSorting"
                        @update:sort-desc="updateSorting"
                        :options.sync="options"
                      >
                        <template v-slot:item.played="{ item }">
                          <v-chip
                            dark
                            small
                            :color="chipColors[getStatus(item)]"
                          >
                            <v-avatar
                              v-show="chipIcons[getStatus(item)]"
                              left
                              :color="chipColors[getStatus(item)]"
                            >
                              <i :class="chipIcons[getStatus(item)]"></i>
                            </v-avatar>
                            <small>{{ item | status }}</small>
                          </v-chip>
                        </template>

                        <template v-slot:item.updated_at="{ item }">
                          <small>{{ item.updated_at | displayDateTime }}</small>
                        </template>
                      </v-data-table>
                    </div>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn text @click="showHistoryDialog.value = false"
                      >Close</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </div>
        </div>
      </div>
      <div class="kt-portlet__body pt-0">
        <div
          class="d-flex align-items-center mb-4"
          v-for="(item, index) in unitProgressRender"
          :key="index"
        >
          <div class="mr-5">
            <i
              style="font-size: 1.7rem; color: #98a2b3 !important"
              :class="item.checked ? checkedClass : 'fal fa-circle'"
            />
          </div>
          <div class="d-flex flex-column font-weight-bold">
            <a
              href="javascript:"
              class="text-dark text-hover-primary mb-1 font-size-lg"
            >
              {{ item.title }}
            </a>
            <span class="text-muted">
              {{ item.description }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="kt-portlet">
      <div
        class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
      >
        <div
          class="kt-portlet__head-label flex-column justify-center align-baseline"
        >
          <h3 class="kt-portlet__head-title">{{ type }} Progress</h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <v-progress-linear color="#D0D5DD" height="30" :value="progress">
          <template v-slot="{ value }">
            <strong>{{ Math.ceil(progress) }}%</strong>
          </template>
        </v-progress-linear>
        <p class="subtitle-2">
          This progress bar updates whenever you complete a unit in this module.
        </p>
      </div>
    </div>

    <div class="kt-portlet" v-if="false">
      <div
        class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm"
      >
        <div
          class="kt-portlet__head-label flex-column justify-center align-baseline"
        >
          <div class="mt-2">
            <h3 class="kt-portlet__head-title">Series Progress</h3>
            <v-chip
              small
              label
              outlined
              color="primary"
              class="font-weight-medium mt-2"
              >Series Certificates: {{ series.noCompletedSeries }}</v-chip
            >
          </div>
        </div>
      </div>
      <div class="kt-portlet__body">
        <v-progress-linear
          color="#D0D5DD"
          height="30"
          :value="series.seriesProgress"
        >
          <template v-slot="{ value }">
            <p class="font-weight-medium caption ma-0">
              <span v-if="series.units_left == '0'"> Series Certified </span>
              <span v-else>
                {{ series.units_left }} more Unit/s to get certified for this
                series
              </span>
            </p>
          </template>
        </v-progress-linear>
        <p class="subtitle-2">
          This progress bar updates whenever you finished a video in this
          series.
        </p>
      </div>
    </div>
  </span>
</template>

<script>
import mixins from '../../../mixins';

export default {
  name: 'UnitProgress',
  props: {
    unitProgressRender: Array,
    progress: Number,
    type: String,
    series: Object,
  },
  data() {
    return {
      showHistoryDialog: false,
      headers: [
        {
          text: 'Status',
          align: 'start',
          sortable: false,
          value: 'played',
        },
        {
          text: 'Date',
          align: 'start',
          sortable: true,
          value: 'updated_at',
        },
      ],
      pagination: {
        total: 1,
        per_page: 5,
        current_page: 1,
      },
      options: {
        groupBy: [],
        groupDesc: [],
        itemsPerPage: 5,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: [],
        sortDesc: [true],
      },
      loading: {
        fetching: false,
        saving: false,
        deleting: false,
      },
      chipColors: {
        Completed: 'success',
        Played: 'info',
        'Quiz Not Answered': 'warning',
      },
      chipIcons: {
        Rewatched: 'fas fa-clock-rotate-left',
        Completed: 'fas fa-badge-check',
        Played: 'fal fa-tv',
        'Quiz Not Answered': 'fa fa-exclamation',
        Assigned: 'fal fa-users-cog',
        Shared: 'fal fa-share',
      },
    };
  },
  methods: {
    changePage(page) {
      this.pagination.current_page = page;
      this.fetchUnitHistory();
    },
    updateSorting() {
      console.log(this.options);
      this.pagination.current_page = 1;
      this.fetchUnitHistory();
    },
    fetchUnitHistory() {
      let params = {
        page: this.pagination.current_page,
        per_page: this.options.itemsPerPage,
        sortBy: this.options.sortBy[0],
        sortDesc: this.options.sortDesc[0],
        unitID: this.unitId,
      };

      this.axios
        .get('/client/lms/user/unit/history', {
          params: params,
        })
        .then(({ data }) => {
          this.$store.commit('clientUnit/setUnitHistory', data);

          this.pagination.total = data.total;
          this.pagination.current_page = data.current_page;
          this.pagination.per_page = Number(this.per_page);
        })
        .finally(() => {
          this.loading.fetching = false;
        });
    },
    getStatus(item) {
      return this.unitStatus(item);
    },
  },
  created() {
    this.fetchUnitHistory();
  },
  computed: {
    checkedClass() {
      return 'fa fa-check-circle animate__animated animate__tada';
    },
    unitId() {
      return this.$route.params.id;
    },
    unitHistory() {
      if (!this.$store.state.clientUnit.unitHistory) {
        return;
      }

      return this.$store.state.clientUnit.unitHistory.data;
    },
  },
  filters: {
    status(item) {
      if (item.played) {
        if (item.is_rewatch) {
          return 'Rewatched';
        } else if (item.finished_watching) {
          if (item.answered_quiz) {
            return 'Completed';
          } else {
            return 'Quiz Not Answered';
          }
        } else {
          return 'Played video';
        }
      } else {
        if (item.assigned_by) {
          return 'Assigned';
        } else {
          return 'Shared By';
        }
      }
    },
    remarks(item) {
      if (item.played) {
        if (item.is_rewatch) {
          return '';
        } else if (item.finished_watching) {
          if (item.answered_quiz) {
            return '';
          } else {
            return 'Please complete the recap/quiz to tag this unit as complete';
          }
        } else {
          return "Seems like you haven't finished the video yet";
        }
      } else {
        if (item.assigned_by) {
          return `Assigned By ${item.assigned_by.name}`;
        } else {
          return `Shared By ${item.shared_by.name}`;
        }
      }
    },
  },
};
</script>
